<div class="mandate-route lifeislife-header-route">

  <div class="back">
    <a [routerLink]="['/products']"
       (click)="onDiscardDraftClick()"
       class="back-link"
    >
      <i class="fa fa-chevron-left"></i>
      <span>Retour à mes polices</span>
    </a>
  </div>

  <header>
    <h1>
      Transférer des polices existantes vers LifeisLife
    </h1>

    <!--    <a [routerLink]="['/products']"-->
    <!--       class="header-subtitle"-->
    <!--    >-->
    <!--      <span i18n>Mes produits</span>-->
    <!--    </a>-->
  </header>

  <div class="in-progress"
       *ngIf="(committing$ | async) || pollingPackage || successSignhereLink != null; else notCommittingForm">
    <h2>Envoi de la demande en cours</h2>
    <p>
      Des documents devront être signés pour compléter votre demande. Vous allez être redirigé dans quelques
      instants vers l'environnement sécurisé de signature électronique SignHere®.
    </p>

    <p>
      Une fois les documents signés, nous vous confirmerons bonne réception par email.
    </p>

    <div class="success" *ngIf="successSignhereLink != null; else noSignhere">

      <p class="actions-link">
        <a (click)="onGoSignClick()">
          Signer les documents
        </a>
      </p>
    </div>
    <ng-template #noSignhere>
      <div class="status-line">
        Envoi des documents en cours, veuillez patienter
        <span class="dots">
        <span>...</span>
        </span>
      </div>
    </ng-template>
  </div>

  <ng-template #notCommittingForm>

    <div class="mandate-form" *ngIf="!(committing$ | async) && successSignhereLink == null && ticketRequest != null">

      <p>
        Vous désirez que LifeisLife prenne en main la gestion de vos polices existantes ?
      </p>
      <p>
        Complétez les informations ci-dessous et signez vos mandats de changement d’intermédiaire en quelques clics !
      </p>

      <form class="form-table ticket-form" #ticketForm="ngForm">
        <div class="row">
          <label>Sujet</label>
          <div>
            <input type="text" pInputText
                   name="ticketSubject"
                   [(ngModel)]="ticketRequest.ticket.subject"
            >
          </div>
        </div>

        <div class="row">
          <label>Message</label>
          <div>
          <textarea pInputTextarea
                    name="ticketMessage"
                    [(ngModel)]="ticketRequest.ticket.description"
                    cfForceFocus
          >
          </textarea>
          </div>
        </div>
      </form>


      <h2>Contrats à tranférer</h2>

      <div *ngFor="let req of ticketRequest.mandateRequests" class="request-item">
        <a class="close-link-button lifeislife-button-link" (click)="onDeleteExistingRequestClick(req)" i18n>
          <i class="fa fa-times"></i>
        </a>
        <cf-insurance-mandate-request-list-item [value]="req"
        ></cf-insurance-mandate-request-list-item>
      </div>

      <form #nextForm="ngForm">
        <ng-template [ngIf]="(nextDraftMandateRequest$ | async) != null">
          <cf-insurance-mandate-request-item name="nextItem" cfForceFocus
                                             [ngModel]="nextDraftMandateRequest$ | async"
                                             (ngModelChange)="onNextRequestChange($event)"
                                             [validationResults]="nextDraftMandateRequestValidationResults$ | async"
          ></cf-insurance-mandate-request-item>

          <div class="next-item-actions">
            <div class="add-contract-link"
                 *ngIf="ticketForm.valid && (nextDraftMandateRequestValidationResults$ | async)?.valid !== false && (committing$ | async) !== true; else notValid">
              <a class="lifeislife-button-link plus-button-link" (click)="onAddAnotherRequestClick()">
                <i class="fa fa-plus"></i>
              </a>
              <a (click)="onAddAnotherRequestClick()"
                 i18n>
                Ajouter un autre contrat
              </a>
            </div>
            <ng-template #notValid>
              <div *ngIf="ticketRequest.mandateRequests.length > 0" class="add-contract-link">
                <a class="lifeislife-button-link minus-button-link" (click)="onCancelNextRequestCLick()">
                  <i class="fa fa-minus"></i>
                </a>
                <a (click)="onCancelNextRequestCLick()"
                   i18n>
                  Enlever ce contrat
                </a>
              </div>
            </ng-template>
          </div>
        </ng-template>
      </form>

      <div class="actions">
        <ng-container *ngIf="(nextDraftMandateRequest$ | async) == null; else withEditingRequest">
          <!-- No next request : add one, send as is if not empty, or cancel the ticket -->
          <a class="lifeislife-button-link" (click)="onCommitDraftClick()" i18n
             *ngIf="ticketRequest.mandateRequests.length > 0"
             [class.disabled]="ticketForm.invalid || ticketRequest.mandateRequests.length <= 0 || (committing$ | async) === true"
          >
            { ticketRequest.mandateRequests.length, plural,
              =1 { Transférer ce contrat }
              other { Transférer ces {{ ticketRequest.mandateRequests.length }} contrats }
              }
          </a>

          <a (click)="onAddNewRequestClick()"
             i18n>
            Ajouter un autre contrat
          </a>

        </ng-container>
        <ng-template #withEditingRequest>

          <!-- editing next request: send all if valid, add another one, cancel ticket -->
          <a class="lifeislife-button-link" (click)="onCommitDraftClick()" i18n
             [class.disabled]="ticketForm.invalid  || (nextDraftMandateRequestValidationResults$ | async)?.valid === false  || (committing$ | async) === true"
          >
            { (ticketRequest.mandateRequests.length + 1), plural,
              =1 { Transférer ce contrat }
              other { Transférer ces {{ ticketRequest.mandateRequests.length + 1 }} contrats }
              }
          </a>

        </ng-template>

        <a (click)="onDiscardDraftClick()" i18n>
          Annuler la demande
        </a>
      </div>

    </div>
  </ng-template>

  <div class="partners">
    <div class="partners-bloc">
      <h1> Nos partenaires </h1>
      <llc-insurance-partner-icons></llc-insurance-partner-icons>
    </div>
  </div>


</div>
